




  <div class="d-flex flex-column">
    <div class="data-name-itinerary font-poppins">
      <h4 class="w-100" style="color: #000000;">FILE N° {{itinerary?.id}}</h4>
    </div>
    <div class="d-flex justify-content-between align-items-center" style=" border: 1px solid #dfdfdf; border-radius: 6px;padding-top: .7em;padding-bottom: .7em;">
      <div class=" d-flex gap-1 align-items-center" style="border-right: 1px solid #dfdfdf; width: 75%">
        <img class="ml-3" width="20px" height="22px" src="../../../../assets/icons/itinerary/placeholder_15914520.svg" alt="">
        <p class="mb-0 ml-1" style="font-family: 'Rubik', serif;font-size: 13px;">
          {{destinySecuency }}
        </p>
      </div>
      <div  class=" d-flex gap-1 align-items-center" style="border-right: 1px solid #dfdfdf; width: 100%">
        <img class="ml-3" width="25px" src="../../../../assets/icons/itinerary/calendar_13937514.svg" alt="">
        <p class="mb-0 ml-1" style="font-family: 'Rubik', serif;font-size: 13px;">
          In: {{ userService.itineraryArrivalDateFull  | date:'dd MM yyyy'}} {{timeArrive}} - Out: {{ userService.itineraryDepartureDateFull  | date:'dd MM yyyy'}} {{timeDropoff}}
          &nbsp;
        <span *ngIf="existHotel()"  style="font-weight: 700; border-left: 1px solid #000000; padding-left: 0.8em;">
        {{qtyDays}} Días {{qtyNights}} {{ qtyNights > 1 ? 'Noches' : 'Noche'}}</span>
      </p>
      </div>
      <div class="d-flex gap-1 align-items-center" style="width: 50%;">
        <img class="ml-3" width="20px" src="../../../../assets/icons/itinerary/persona.svg" alt="">
        <p class="mb-0 ml-1" style="font-family: 'Rubik', serif;font-size: 13px;">{{ adults}} {{ adults > 1 ? 'adultos' : 'adulto'}}  - {{children}} {{children === 1 ? 'niño' : 'niños'}}</p>
      </div>
    </div>



          <div *ngIf="itinerary?.flights && itinerary?.flights.length > 0" class="d-flex justify-content-between align-items-center px-2"
                style="height:53px; position:relative; width:100%;  border: 1px solid #dfdfdf; border-radius: 6px; margin-top: 10px;"
                (mouseenter)="changeTooltipFlightVisible(true)" (mouseleave)="changeTooltipFlightVisible(false)">
            <div  *ngIf="flightsInternal && flightsInternal.length > 0"
                  class="d-flex justify-content-between align-items-center px-1"
                  style="width: 49.15%; cursor: pointer; border-right: 1px solid #dfdfdf;"
                  [ngStyle]="{'cursor': itinerary?.flights.length > 1 ? 'pointer' : 'default'}">
              <div *ngIf="itinerary?.flights[0]?.arrivalIn" class="d-flex gap-1 align-items-center justify-content-center" style="width: 30%; gap:5px;">

              <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 11px;font-weight: 700; ">
                {{getActualFlyInternal(flightsInternal, 'airportIataCodeOut')}} </p>
              <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 11px;">
                {{getActualFlyInternal(flightsInternal, 'departureOut') | date: 'dd MMM yyyy'}}
              </p>
              </div>
              <div class="d-flex flex-column align-items-center justify-content-center" style="width: 44%;margin-bottom: 15px;">
                <p  class="mb-0 mt-2" style="font-family: 'Rubik', serif;font-size: 12px;line-height: 1;">{{afterDateFlyOut(getActualFlyInternal(flightsInternal, 'departureOut'), getActualFlyInternal(flightsInternal, 'arrivalOut'))}}</p>

                <div class="d-flex align-items-center w-100 justify-content-center">
                  <div style="height: 1px; border-bottom: 1px dashed #000000;width: 70%;"></div>
                  <i class="fa fa-angle-right" style="font-size: 1rem;" aria-hidden="true"></i>
                </div>
              </div>
              <div class="d-flex gap-1 align-items-center justify-content-center" style="width: 32.75%; gap:5px;"
                    [ngStyle]="{'border-right': itinerary?.flights[0]?.arrivalIn ? '1px solid #dfdfdf:' : ''}">

                <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 11px;font-weight: 700; ">{{getActualFlyInternal(flightsInternal, 'iataCityArrivalOut')}}</p>
                <p class="mb-0" style="font-family: 'Rubik', serif;font-size: 11px;">
                  {{getActualFlyInternal(flightsInternal, 'arrivalOut') | date: 'dd MMM yyyy'}}
                </p>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center" style="cursor: pointer; width:100%" >
              <div *ngIf="itinerary?.flights[0]?.arrivalIn" class="w-100 d-flex gap-1 align-items-center">
                <img class="ml-3" width="28px" style="transform: rotate(25deg);" src="../../../../assets/icons/itinerary/AVIONLINEA.svg" alt="">
              <p class="mb-0 ml-1" style="font-family: 'Rubik', serif;font-size: 13px;"> <span style="font-weight: 700">{{itinerary?.flights[0]?.arrivalIn | date: 'dd MM yyyy'}}</span><span class="ml-1"> {{itinerary?.flights[0]?.airlineIn}} - {{itinerary?.flights[0]?.flyNumberIn}}  Arr: {{getHourFly(itinerary?.flights[0]?.arrivalIn)}} {{itinerary?.flights[0]?.airportIataCodeIn}} </span></p>
              </div>
              <div *ngIf="itinerary?.flights[0]?.departureOut" class="w-100 d-flex gap-1 align-items-center"
                    [ngStyle]="{'border-right': itinerary?.flights[0]?.arrivalIn ? '1px solid #dfdfdf:' : ''}">
                <img class="ml-3" width="28px" src="../../../../assets/icons/itinerary/AVIONLINEA.svg" alt="">
              <p class="mb-0 ml-1" style="font-family: 'Rubik', serif;font-size: 13px;"> <span style="font-weight: 700">{{itinerary?.flights[0]?.departureOut | date: 'dd MM yyyy'}}</span><span class="ml-1"> {{itinerary?.flights[0]?.airlineOut}} - {{itinerary?.flights[0]?.flyNumberOut}}    Dep: {{getHourFly(itinerary?.flights[0]?.departureOut)}} {{itinerary?.flights[0]?.airportIataCodeOut}} </span></p>
              </div>
            </div>

            <ng-container *ngIf="tooltipFlight && flightsInternal && flightsInternal.length > 0">

              <div
                class="d-flex justify-content-between align-items-center w-100 shadow-md"
                style=" border: 1px solid #dfdfdf;
                        border-radius: 6px;
                        padding-top: .35em;
                        padding-bottom: .35em;
                        background-color: #f3fef9;
                        position: absolute;
                        bottom: -130px;
                        left: 0;
                        z-index: 99999;">
                <div class="d-flex justify-content-between align-items-start px-4" style="width: 100%;">
                  <ng-container *ngFor="let fly of getFlyArr(itinerary?.flights); let i = index">
                    <div class="d-flex flex-column align-items-center" style="min-width: 110px;">
                      <img #icons src="../../../assets/icons/itinerary/lugar.svg" style="width: 40px;" alt="">
                      <p
                          class="mb-0"
                          style="font-family: 'Rubik', serif;font-weight: 600;"
                          [ngStyle]="{'color': i === 0 || (i === getFlyArr(itinerary?.flights).length - 1) ? colorFlight : '#000000'}">{{ getDataTooltip(fly, i, 'iata')}}</p>
                      <p
                          class="mb-0"
                          style="font-family: 'Rubik', serif;font-weight: 500;text-transform: capitalize;" >{{ getDataTooltip(fly, i, 'date') | date: 'dd MMM'}}</p>
                      <p
                          class="mb-0"
                          style="font-family: 'Rubik', serif;font-weight: 400;" >{{getHourFly(getDataTooltip(fly, i, 'date'))}}</p>



                    </div>
                    <div class="d-flex align-items-center" style="width: 80%;"  *ngIf="i !== getFlyArr(itinerary?.flights).length - 1">
                      <div
                            class="mt-2"
                            style="height: 2px; border-bottom: 2px dashed #000000; width: 75%;"></div>
                            <img class="mt-2 mx-2" src="../../../assets/icons/itinerary/airplane-plane-svgrepo-com.svg" style="width: 30px;" alt="">
                      <div
                            class="mt-2"
                            style="height: 2px; border-bottom: 2px dashed #000000; width: 75%;"></div>

                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>

  </div>
